import React, { Component, Fragment } from 'react'
import './index.css'
import auto from './timer.svg'
import logoRed from './dsideLogo.svg'
import shahmat from './queen.png'
import horse from './horse.svg'
import memory from './head.svg'
import web from './planet.svg'
import Max from './peopleCompany/Max.png'
import Rostick from './peopleCompany/rostick.png'
import Pavel from './peopleCompany/paul.png'
import GRU from './peopleCompany/gru.png'
import Maksym from './peopleCompany/maksym.png'
import Oleksii from './peopleCompany/lorem5.png'
import arrow from './arrow.svg'
import Translate from 'translate-components'
import { reactTranslateChangeLanguage } from 'translate-components'
import Helmet from 'react-helmet-async'
import Footer from '../../Basic/Footer';
import scrollToComponent from 'react-scroll-to-component';
import  PricingFeatures  from '../../Basic/TrustBlocks/PricingFeatures';
import ScrollAnimation from 'react-animate-on-scroll'

export default class AboutUs extends Component {
  constructor() {
    super()

    this.state = {
      dataTeam: [
        {
          active: false,
          checkName: 'Max',
          img: Max,
          information: {
            name: 'Maksym Vydyborets',
            position: 'Art director at DSIDE, founder',
            description: 'Has got 10 years of experience at UX-UI and graphic design. Knows perfectly well what your client wants to see.',
            behance: 'https://dishots.com/u/DSIDE',
            instagram: 'https://instagram.com/mcseem7',
            linkedin: 'https://www.linkedin.com/in/maksym-vydyborets-1a48131a5/'
          }
        },
        {
          active: false,
          checkName: 'Rostick',
          img: Rostick,
          information: {
            name: 'Rostislav Verbakhovski',
            position: 'Head of Development, Co-Founder',
            description: 'Graduated from the Maritime Academy in Gdynia. Has a strong business acumen.',
            linkedin: 'https://www.linkedin.com/in/verbakhovsky/'
          }
        },
        {
          active: false,
          checkName: 'Pavel',
          img: Pavel,
          information: {
            name: 'Pavel Litvinau',
            position: 'Regional represantative in CZ',
            description: 'Organizer of mass events with ten years of experience. Regional represantative of DSIDE in Czech Republic.',
            instagram: 'https://www.instagram.com/pawel_litvinov/'
          }
        },
        {
          active: false,
          checkName: 'GRU',
          img: GRU,
          information: {
            name: 'Eduard Polianski',
            position: 'Back-End Developer',
            description: 'Has got 5 years of experience at backend programming. Open source enthusiast. Easily creates high-load services.',
            linkedin: 'https://www.linkedin.com/in/eduardpolianski/'
          }
        },
        {
          active: false,
          checkName: 'Maksym',
          img: Maksym,
          information: {
            name: 'Maksym Kravchenko',
            position: 'Graphic Designer, co-founder',
            description: 'Five years of commercial graphic experience. Can convey emotions through images. Creating logos is his strong side.',
            instagram: 'https://www.instagram.com/young.mksm_13',
            linkedin: 'https://www.linkedin.com/in/%D0%BC%D0%B0%D0%BA%D1%81%D0%B8%D0%BC-%D0%BA%D1%80%D0%B0%D0%B2%D1%87%D0%B5%D0%BD%D0%BA%D0%BE-b879551a5/'
          }
        }
      ],
      activeTeam: true,
      result: {}
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  showInformation = (teamMan) => {
    this.setState({ activeTeam: false })
    this.state.dataTeam.map((item) => {
      if (teamMan === item.checkName) {
        this.setState({ result: item });
        scrollToComponent(this.TeamMember, { offset: 0, align: 'top', duration: 1900});
      } return null;
    })

  }

  hideMeetDeveloper = () => {
    this.setState({ activeTeam: true })
  }

  componentDidUpdate() {
    reactTranslateChangeLanguage.bind(this, localStorage.getItem('lang'))()
  }

  render() {
console.log('y', this.state);
    return (
      <Fragment>

      <div>
        <Helmet>
          <title> Dside About </title>
        </Helmet>
        <div className="aboutus__container">
          <div className="aboutus__wrapper">
            <div className="aboutus__title-advantage">
              <h1><Translate>advantage</Translate></h1>
            </div>
            <div className="about__us-content">
              <div className="dside__shahmat-img">
                <img src={shahmat} width={110} alt="" />
              </div>
              <div className="dside__what-about">
                <div className="dside__red-logo">
                  <img src={logoRed} alt=""/>
                </div>
                <div className="dside__what-content">

                  <div className="about__company-dside">
                    <p><Translate>DSIDE is not another digital agency. DSIDE Branding Agency is a digital agency which is widely being advised. Established in Warsaw in 2017.</Translate>
                    </p>
                  </div>
                </div>
              </div>


            </div>
            <div className="dside__meet_team"  ref={(section) => { this.TeamMember = section; }} >

              <div className="meet__team-title">
                <h4>{this.state.activeTeam ? <Translate>meet our team</Translate> : null}</h4>
              </div>


              <div className="meet__team__dside" >



                <div className={`fade__team ${this.state.activeTeam ? 'fadeNo' : ''}`}  >
                  <div className="dside__team-man"
                    onClick={() => this.showInformation('Max')}>
                    <img src={Max} alt="" />
                  </div>
                  <div className="dside__team-man">
                    <img src={Maksym} onClick={() => this.showInformation('Maksym')} alt="" />
                  </div>
                  <div className="dside__team-man">
                    <img src={Rostick} alt="" onClick={() => this.showInformation('Rostick')} />
                  </div>
                  <div className="dside__team-man">
                    <img src={Pavel} alt="" onClick={() => this.showInformation('Pavel')} />
                  </div>
                  <div className="dside__team-man">
                    <img src={GRU} alt="" onClick={() => this.showInformation('GRU')} />
                  </div>
                </div>

                {this.state.activeTeam ? null :


                  <div className="dside__meet-developer">

                    <div className="left__data-dev">

                      <div className="photo__image-developer">
                        <img src={this.state.result.img} alt="" className={this.state.result.checkName} />
                      </div>
                    </div>
                    <div className="right__data-dev">

                      <div className="post_developer">

                        <div className="button__back-team" onClick={this.hideMeetDeveloper}>
                          <img src={arrow} alt="" />
                        </div>

                        <div className="developer__naming">
                          <div className="name-developer">
                            <h4><Translate>{this.state.result.information.name}</Translate></h4>
                          </div>

                          <div className="position-developer">
                            <p><Translate>{this.state.result.information.position}</Translate></p>
                          </div>
                        </div>
                      </div>

                      <div className="about__developer">

                        <p><Translate>{this.state.result.information.description}</Translate></p>

                      </div>

                      <div className="contact__links-developer">

                        {
                          this.state.result.information.behance === undefined ? null : <a href={this.state.result.information.behance}  target='_blank' className="social__icon-behance" > </a>
                        }




                        {
                          this.state.result.information.instagram === undefined ? null : <a href={this.state.result.information.instagram} target='_blank'  className="social__icon-instagram" > </a>
                        }
                        {
                          this.state.result.information.linkedin === undefined ? null : <a href={this.state.result.information.linkedin} target='_blank'  className="social__icon-linkedin" > </a>
                        }

                      </div>

                    </div>
                  </div>

                }



              </div>



            </div>



          </div>
        </div>
        <div className="about__us-content second-cont">
        <div className="dside__about-content">


                <div className="dside__whyus-content">


                  <div className="about__dside-process">

                    <ul className="dside__business_process">
                      <li>
                        <div className="logo__process logo__business__automated">
                          <img src={auto} alt="" />
                        </div>
                        <div className="title__business-process">
                          <div className="number__bus-process">
                            01
                            </div>
                          <div className="business__title">
                            <p><Translate>Automated business</Translate></p>
                          </div>
                        </div>
                        <div className="description__business-process">
                          <p><Translate>Do so that your business is
                            working while you are solving
                              more important issues</Translate></p>
                        </div>
                      </li>
                      <li>
                        <div className="logo__process logo__business__automated">
                          <img src={memory} alt="" />
                        </div>
                        <div className="title__business-process">
                          <div className="number__bus-process">
                            02
                            </div>
                          <div className="business__title">
                            <p><Translate>Build brands</Translate></p>
                          </div>
                        </div>
                        <div className="description__business-process">
                          <p><Translate>Branded companies sell their products much more expensive, so what's stopping you?</Translate></p>
                        </div>
                      </li>
                      <li>
                        <div className="logo__process logo__business__automated">
                          <img src={horse} alt="" />
                        </div>
                        <div className="title__business-process">
                          <div className="number__bus-process">
                            03
                            </div>
                          <div className="business__title">
                            <p><Translate>Memorable logos</Translate></p>
                          </div>
                        </div>
                        <div className="description__business-process">
                          <p><Translate>Make your client remember
                              your company</Translate></p>
                        </div>
                      </li>
                      <li>
                        <div className="logo__process logo__business__automated">
                          <img src={web} alt="" />
                        </div>
                        <div className="title__business-process">
                          <div className="number__bus-process">
                            04
                            </div>
                          <div className="business__title">
                            <p><Translate>Expirienced websites</Translate></p>
                          </div>
                        </div>
                        <div className="description__business-process">
                          <p><Translate>Which perform specific
                              business tasks</Translate></p>
                        </div>
                      </li>
                    </ul>

                  </div>

                </div>


              </div>
              </div>
      </div>
                   <div className="row"><PricingFeatures/></div>
      <Footer/>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/DynamicContent/About/index.js